import { render, staticRenderFns } from "./OpenDialogs.vue?vue&type=template&id=10d0f752&scoped=true&"
import script from "./OpenDialogs.vue?vue&type=script&lang=js&"
export * from "./OpenDialogs.vue?vue&type=script&lang=js&"
import style0 from "./OpenDialogs.vue?vue&type=style&index=0&id=10d0f752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0f752",
  null
  
)

export default component.exports